import { render, staticRenderFns } from "./FctDropDown.vue?vue&type=template&id=54b5b019&scoped=true"
import script from "./FctDropDown.vue?vue&type=script&lang=js"
export * from "./FctDropDown.vue?vue&type=script&lang=js"
import style0 from "./FctDropDown.vue?vue&type=style&index=0&id=54b5b019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5b019",
  null
  
)

export default component.exports